import * as React from 'react';
import classnames from 'classnames';
import { formatTimestamp } from '@bytebrand/fe-ui-core-autobahn/utils';
import styles from './CarInvoices.styl';
class CarInvoices extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "onPDFClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                this.props.getUrl(event.currentTarget.dataset.url, event.currentTarget.dataset.date);
            }
        });
        Object.defineProperty(this, "onCarSellTableArrowClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                const { carsTablesDateKeys } = this.state;
                const dateKey = event.currentTarget.dataset.date;
                const isInArray = carsTablesDateKeys.find((e) => e === dateKey);
                let newCarsTablesDateKeys = [];
                if (isInArray) {
                    newCarsTablesDateKeys = carsTablesDateKeys.filter((e) => e !== dateKey);
                }
                else {
                    newCarsTablesDateKeys = carsTablesDateKeys.concat([dateKey]);
                }
                this.setState({ carsTablesDateKeys: newCarsTablesDateKeys });
            }
        });
        Object.defineProperty(this, "toggleCarInvoiceOpenRow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                const { carInvoicesIds } = this.state;
                const carInvoiceId = parseInt(event.currentTarget.dataset.invoiceid, 10);
                const isInArray = carInvoicesIds.find((e) => e === carInvoiceId);
                let newCarInvoicesId = [];
                if (isInArray) {
                    newCarInvoicesId = carInvoicesIds.filter((e) => e !== carInvoiceId);
                }
                else {
                    newCarInvoicesId = carInvoicesIds.concat([carInvoiceId]);
                }
                this.setState({ carInvoicesIds: newCarInvoicesId });
            }
        });
        Object.defineProperty(this, "renderCarSellTable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (date, arrayOfInvoices, t) => {
                const { carsTablesDateKeys } = this.state;
                const shouldTableBeOpened = carsTablesDateKeys.find((e) => e === date);
                const sumOfMoney = arrayOfInvoices.reduce((accumulator, currentValue) => accumulator + currentValue.amount_untaxed, 0);
                const currencyName = arrayOfInvoices.length && arrayOfInvoices[0].currency_id[1];
                return (React.createElement("div", { className: styles.tableWrapper, key: date },
                    React.createElement("div", { className: styles.tableHeader },
                        React.createElement("span", { className: classnames(styles.headerItem, styles.width12dot3) },
                            React.createElement("b", null, formatTimestamp({ timestamp: date, format: 'MMMM' })),
                            " ",
                            formatTimestamp({ timestamp: date, format: 'YYYY' })),
                        React.createElement("span", { className: classnames(styles.headerItem, styles.width60) },
                            "PKW ",
                            t('overview')),
                        React.createElement("span", { className: classnames(styles.headerItem, styles.width25dot5) },
                            t('totalBill'),
                            ": ",
                            React.createElement("b", null,
                                sumOfMoney,
                                " ",
                                currencyName)),
                        React.createElement("span", { className: classnames(styles.headerItem, { [styles.arrowButton]: !shouldTableBeOpened, [styles.arrowDown]: shouldTableBeOpened }), onClick: this.onCarSellTableArrowClick, "data-date": date })),
                    React.createElement("div", { className: classnames({ [styles.carSellBodyFull]: !shouldTableBeOpened, [styles.carSellBodyEmpty]: shouldTableBeOpened }) },
                        React.createElement("div", { className: styles.tableSubHeader },
                            React.createElement("span", { className: styles.dateColumnName }, t('dateColumnName')),
                            React.createElement("span", { className: styles.markeColumnName }, t('markeColumnName')),
                            React.createElement("span", { className: styles.modelColumnName }, t('modelColumnName')),
                            React.createElement("span", { className: styles.billNumberColumnName }, t('billNumberColumnName')),
                            React.createElement("span", { className: styles.sumColumnName }, t('sumColumnName')),
                            React.createElement("span", { className: styles.statusColumnName }, t('statusColumnName'))),
                        arrayOfInvoices.map((invoice) => this.renderCarSellRow(invoice)))));
            }
        });
        Object.defineProperty(this, "renderCarSellRow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (invoice) => {
                const { t } = this.props;
                const { carInvoicesIds } = this.state;
                const shouldInvoiceBeOpened = carInvoicesIds.find((e) => e === invoice.id);
                const isRedText = invoice.state === 'draft' || invoice.state === 'open' || invoice.state === 'cancel';
                return (React.createElement(React.Fragment, { key: invoice.id },
                    React.createElement("div", { className: styles.carSellRow },
                        React.createElement("span", { className: classnames({ [styles.arrowDownFromLeft]: shouldInvoiceBeOpened, [styles.arrowLeft]: !shouldInvoiceBeOpened }), onClick: this.toggleCarInvoiceOpenRow, "data-invoiceid": invoice.id }),
                        React.createElement("span", { className: styles.dateColumnValue }, invoice.date_invoice),
                        React.createElement("span", { className: styles.markeColumnName }, invoice.brand_id[1]),
                        React.createElement("span", { className: styles.modelColumnName }, invoice.model_id[1]),
                        React.createElement("span", { className: styles.billNumberColumnName }, invoice.number),
                        React.createElement("span", { className: styles.sumColumnName },
                            React.createElement("b", null,
                                invoice.amount_untaxed,
                                " ",
                                invoice.currency_id[1])),
                        React.createElement("span", { className: classnames(styles.statusColumnValue, { [styles.redText]: isRedText, [styles.greenText]: !isRedText }) }, t(invoice.state)),
                        React.createElement("span", { className: styles.pdfButton, "data-date": invoice.date_invoice, "data-url": invoice.pdf_download, onClick: this.onPDFClick })),
                    shouldInvoiceBeOpened ? (React.createElement("div", { className: styles.openedCarSellRow },
                        React.createElement("div", { className: styles.openedCarSellRowHeader },
                            React.createElement("span", { className: styles.mengeTitle }, t('amount')),
                            React.createElement("span", { className: styles.EinzelpreisTitle }, t('price')),
                            React.createElement("span", { className: styles.GesamtbetragTitle }, t('totalAmount'))),
                        invoice.invoice_line_ids.map((line) => (React.createElement("div", { className: styles.openedCarSellRowValues, key: line.id },
                            React.createElement("span", { className: styles.textValue }, line.name),
                            React.createElement("span", { className: styles.mengeValue }, line.quantity),
                            React.createElement("span", { className: styles.EinzelpreisValue },
                                line.price_subtotal,
                                " ",
                                invoice.currency_id[1]),
                            React.createElement("span", { className: styles.GesamtbetragValue },
                                line.price_total,
                                " ",
                                invoice.currency_id[1])))))) : null));
            }
        });
        this.state = {
            isCarSellTableShowed: true,
            additionalServices: true,
            productInvoicesIds: [],
            carInvoicesIds: [],
            tablesDateKeys: [],
            carsTablesDateKeys: [],
            shouldAllTablesBeClosed: false
        };
    }
    render() {
        const { date, arrayOfInvoices, t } = this.props;
        return (this.renderCarSellTable(date, arrayOfInvoices, t));
    }
}
export default CarInvoices;
